import React from "react";
import Picker from "react-mobile-picker";

function MyPicker({ values = [], value, setValue, isTime }) {
  return (
    <Picker
      value={value}
      onChange={(el) => {
        setValue(el);
      }}
      height="145"
      width="100px"
      className={isTime ? "picker-text-color" : "picker-text-color-big"}
    >
      {Object.keys(values).map((name) => (
        <Picker.Column key={name} name={name}>
          {(values[name] ?? []).map((option) => (
            <Picker.Item key={option} value={option}>
              {({ selected }) => (
                <div
                  className={
                    selected
                      ? isTime
                        ? "picker-selected-time"
                        : "picker-selected"
                      : "picker-unselected"
                  }
                >
                  {option}
                </div>
              )}
            </Picker.Item>
          ))}
        </Picker.Column>
      ))}
    </Picker>
  );
}

export default MyPicker;
